/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolPublicIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-public"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M12 23.2Q12 23.2 10.84 23.2Q9.68 23.2 7.64 22.31Q5.6 21.43 4.09 19.91Q2.58 18.4 1.69 16.36Q0.8 14.32 0.8 12Q0.8 9.68 1.69 7.64Q2.58 5.6 4.09 4.09Q5.6 2.58 7.64 1.69Q9.68 0.8 12 0.8Q14.32 0.8 16.36 1.69Q18.4 2.58 19.91 4.09Q21.43 5.6 22.31 7.64Q23.2 9.68 23.2 12Q23.2 14.32 22.31 16.36Q21.43 18.4 19.91 19.91Q18.4 21.43 16.36 22.31Q14.32 23.2 12 23.2ZM10.95 20.5L10.95 18.4Q10.07 18.4 9.44 17.76Q8.8 17.13 8.8 16.25L8.8 15.2L3.65 10.05Q3.58 10.53 3.51 11.01Q3.45 11.5 3.45 12Q3.45 15.28 5.59 17.69Q7.72 20.1 10.95 20.5ZM18.3 17.75Q19.43 16.57 19.99 15.09Q20.55 13.6 20.55 11.97Q20.55 9.32 19.1 7.16Q17.65 5 15.2 4.05L15.2 4.47Q15.2 5.35 14.56 5.99Q13.93 6.63 13.05 6.63L10.95 6.63L10.95 8.78Q10.95 9.2 10.64 9.51Q10.32 9.82 9.9 9.82L7.7 9.82L7.7 11.97L14.15 11.97Q14.57 11.97 14.89 12.29Q15.2 12.6 15.2 13.03L15.2 16.3L16.3 16.3Q17 16.3 17.55 16.7Q18.1 17.1 18.3 17.75Z" fill={color} />
    </svg>
  );
}
